import useCurrentUser from './useCurrentUser';

export default useCurrentUser;
